export const APP_NAME = 'Kolumi';
export const APP_VERSION = '0.5.4'; // 2026-02-20: Compact ReadingPane - scrollable content area

export const API_URL = '/api';

export const COLORS = {
  primary: '#6366f1',
  primaryHover: '#818cf8',
  violet: '#8b5cf6',
  cyan: '#06b6d4',
  success: '#10b981',
  warning: '#f59e0b',
  error: '#ef4444',
};
